const s = {
  name: "ChipReset",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,20c0,3.9-3.1,7-7,7c-3.5,0-6.4-2.6-6.9-6h2c0.5,2.3,2.5,4,4.9,4c2.8,0,5-2.2,5-5s-2.2-5-5-5
			c-1.6,0-3.1,0.8-4,2h3v2h-6v-6h2v2.1c1.3-1.3,3.1-2.1,5-2.1C23.9,13,27,16.1,27,20z"/>
		<path class="st0" d="M6,11c0-2.8,2.2-5,5-5h18c2.8,0,5,2.2,5,5v18c0,2.8-2.2,5-5,5H11c-2.8,0-5-2.2-5-5V11z M11,8
			c-1.7,0-3,1.3-3,3v18c0,1.7,1.3,3,3,3h18c1.7,0,3-1.3,3-3V11c0-1.7-1.3-3-3-3H11z"/>
		<path class="st0" d="M23,0v4h-2V0H23z"/>
		<path class="st0" d="M19,4V0h-2v4H19z"/>
		<path class="st0" d="M15,0v4h-2V0H15z"/>
		<path class="st0" d="M27,4V0h-2v4H27z"/>
		<path class="st0" d="M23,36v4h-2v-4H23z"/>
		<path class="st0" d="M19,40v-4h-2v4H19z"/>
		<path class="st0" d="M15,36v4h-2v-4H15z"/>
		<path class="st0" d="M27,40v-4h-2v4H27z"/>
		<path class="st0" d="M36,21h4v2h-4V21z"/>
		<path class="st0" d="M40,17h-4v2h4V17z"/>
		<path class="st0" d="M36,13h4v2h-4V13z"/>
		<path class="st0" d="M40,25h-4v2h4V25z"/>
		<path class="st0" d="M0,21h4v2H0V21z"/>
		<path class="st0" d="M4,17H0v2h4V17z"/>
		<path class="st0" d="M0,13h4v2H0V13z"/>
		<path class="st0" d="M4,25H0v2h4V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as ChipReset
};
